const microsoftCalendarIcon = `
<svg
   viewBox="0 0 262.12579 262.07257"
   width="262.12579"
   height="262.07257"
   version="1.1"
   id="svg38"
   xml:space="preserve"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs42" /><g
     id="g343"
     transform="translate(-516.27911,77.315308)"><path
       fill="#1976d2"
       d="M 28,13 H 42.533 C 43.343,13 44,13.657 44,14.467 V 33.533 C 44,34.343 43.343,35 42.533,35 H 28 Z"
       id="path2" /><rect
       width="14"
       height="15.542"
       x="28"
       y="17.958"
       fill="#ffffff"
       id="rect4" /><g
       id="g347"><polygon
         fill="#1976d2"
         points="27,44 4,39.5 4,8.5 27,4 "
         id="polygon6" /><path
         fill="#ffffff"
         d="m 15.25,16.5 c -3.176,0 -5.75,3.358 -5.75,7.5 0,4.142 2.574,7.5 5.75,7.5 3.176,0 5.75,-3.358 5.75,-7.5 0,-4.142 -2.574,-7.5 -5.75,-7.5 z M 15,28.5 c -1.657,0 -3,-2.015 -3,-4.5 0,-2.485 1.343,-4.5 3,-4.5 1.657,0 3,2.015 3,4.5 0,2.485 -1.343,4.5 -3,4.5 z"
         id="path8" /></g><rect
       width="2.7"
       height="2.9000001"
       x="28.047001"
       y="29.737"
       fill="#1976d2"
       id="rect10" /><rect
       width="2.7"
       height="2.9000001"
       x="31.448"
       y="29.737"
       fill="#1976d2"
       id="rect12" /><rect
       width="2.7"
       height="2.9000001"
       x="34.848999"
       y="29.737"
       fill="#1976d2"
       id="rect14" /><rect
       width="2.7"
       height="2.9000001"
       x="28.047001"
       y="26.159"
       fill="#1976d2"
       id="rect16" /><rect
       width="2.7"
       height="2.9000001"
       x="31.448"
       y="26.159"
       fill="#1976d2"
       id="rect18" /><rect
       width="2.7"
       height="2.9000001"
       x="34.848999"
       y="26.159"
       fill="#1976d2"
       id="rect20" /><rect
       width="2.7"
       height="2.9000001"
       x="38.25"
       y="26.159"
       fill="#1976d2"
       id="rect22" /><rect
       width="2.7"
       height="2.9000001"
       x="28.047001"
       y="22.705999"
       fill="#1976d2"
       id="rect24" /><rect
       width="2.7"
       height="2.9000001"
       x="31.448"
       y="22.705999"
       fill="#1976d2"
       id="rect26" /><rect
       width="2.7"
       height="2.9000001"
       x="34.848999"
       y="22.705999"
       fill="#1976d2"
       id="rect28" /><rect
       width="2.7"
       height="2.9000001"
       x="38.25"
       y="22.705999"
       fill="#1976d2"
       id="rect30" /><rect
       width="2.7"
       height="2.9000001"
       x="31.448"
       y="19.112"
       fill="#1976d2"
       id="rect32" /><rect
       width="2.7"
       height="2.9000001"
       x="34.848999"
       y="19.112"
       fill="#1976d2"
       id="rect34" /><rect
       width="2.7"
       height="2.9000001"
       x="38.25"
       y="19.112"
       fill="#1976d2"
       id="rect36" /><image
       width="3.1372547"
       height="2.8070176"
       preserveAspectRatio="none"
       xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA
AXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOYSURBVHgB7ZlfSFNRHMd/Zzf/DGNuy8o/s2Z/
IJrpQCNMoT0Y+NSTzcdAsh4diNlb9FZCtB7NCOrNVU+9CPoQlAllCOUkiLTQNghzupKNxJ3O78xz
3dbd3dzd3Ao/Y9xz7nbv+d7z+57f7+6OQJaoHJi2RijYJZDOARArAerwDTaYQCN7IANQDBDJQSLQ
CITYCaV2SsEoyd+g7JUdUgpMJkZWQLMnJqXA/f0zdkmK2PMlRlFg1bX3d9nIDgLESiFihEj+xCiB
M+hipi4IMUrooMDZFaiVjPLgdmCLUIu93YU+g67/I8S1piLosJWDoVQHXl8YRmeDsFOkFHjzQjX0
tO6L27cQWIfuR1/A6w9DriFqJlYSJ1gNbUDn0JyqSP9gA6uWNKNFUj3wgW+TzqCzySSLC4Y3YORt
AMr1EnTUG1ioJd5+eMkKZ259hHQZfrkEwxNLvH3vogV6nyzydk9rBUzOr8GML8T7b66fkI9JKrDv
/EFZXLv7EyyysCK140Uw5jrORaI3W46UweTcGqQDnkucBxFt3I8Rif1MoLiKbVV6PjgyMhWIOxD9
N/xqSe7j1ecSxRmsNRfJbQ8TmIhnagX62qMzbKspBTVez/3iW7SEs9kELUfLosdV6+Hp1broeKZi
liUMsMpmMi2BtqqtQZUWwULgt9zGk6vROTTPt2eZFdAOd8a/8/6zK3XQeT/6WV/7AXYha7JVfLdP
ycf/m4k61nMW5sVE86JHBd7NlZeMrqbo7yaLuZiFtTSuL9q2Gj0YmAUOKURDUeCMLxw3gAiLwHna
KLcXltdBjYlND7bCXjCU6OS+c9kot08yS8WmmVgUQ+z1h7gnkMttFWwWt64MPdfVZJb7o7OroAbO
Pr7RtyLNiIiIdmyaSYxW0jzomVrmxsbVN9Z7jNffIDtJV7OZ12QEB/W8W4Fcolrq3E4LryhKJCZw
JbDUTXz+yc+PF4rJXWSAepZmREgxKonZIGWpQ1yeRT71PW3xyRgH6X78VVWcIN00IypXIinvZm48
98MDVjkwkeIMoDdx5QbDEdgJ0rofjJa3H5AJ6aYZTQK1YNms6fggwPstJPexhIo27sd3XgQm5tDt
wEzkzrlAXMmggd0f7lopfIFoRErJCyhQ4gxc0z9tZ/e0dkqkRkKJXUfYA0wAI2SI1gXyl0AlUDTV
SYc3KDi2K3pHBCqRrui8CVSi0jVt1ZVIjREmmD2udaDobPwN8QcV955vnlkYXAAAAABJRU5ErkJg
gg==
"
       id="image357"
       x="60.2724"
       y="23.856632" /><image
       width="314.83881"
       height="314.83881"
       preserveAspectRatio="none"
       xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA2gAAANoCAYAAAC1Fsk9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA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"
       id="image369"
       x="122.896"
       y="-101.84952" /><path
       style="stroke-width:0.361054"
       d="m 591.10693,170.04428 -74.82784,-14.67291 0.0897,-101.630609 0.0897,-101.630611 75.09916,-14.706518 c 41.30454,-8.088585 75.13979,-14.712107 75.18943,-14.718938 0.0496,-0.0068 0.0903,58.965699 0.0903,131.050066 0,104.63063 -0.091,131.05441 -0.45131,131.02246 -0.24823,-0.022 -34.12384,-6.64283 -75.27915,-14.71294 z m 5.89909,-67.932 c 3.45416,-0.8778 8.16031,-3.076625 11.13429,-5.202197 3.13179,-2.238367 8.17441,-7.612471 10.52134,-11.212981 12.14897,-18.638161 12.03781,-45.861901 -0.26254,-64.300119 -2.31271,-3.46674 -7.2741,-8.707748 -10.23294,-10.809654 C 605.40173,8.6235246 601.63725,6.7412003 598.41772,5.7128942 594.5376,4.4735918 587.14548,4.2806267 583.06633,5.3121571 568.72797,8.9380246 557.15486,22.895233 553.48565,40.986579 c -3.84465,18.956297 1.13692,38.832883 12.77034,50.954044 3.4983,3.644963 6.36676,5.845491 9.95693,7.638422 5.06568,2.529805 7.77007,3.162895 13.75255,3.219445 3.10883,0.0294 4.91883,-0.14702 7.04055,-0.68621 z m -11.4057,-19.273929 c -7.61749,-1.696345 -13.59619,-9.337678 -15.99127,-20.438303 -0.97786,-4.53218 -1.02998,-12.923992 -0.10636,-17.128058 1.49778,-6.817556 4.25271,-12.27077 8.12802,-16.08888 10.84326,-10.683239 25.07953,-3.077459 29.35756,15.684388 0.99527,4.364886 1.0598,13.105083 0.12795,17.330032 -3.11387,14.11817 -12.09902,22.737879 -21.5159,20.640821 z m 88.09709,38.239269 v -4.88058 h 45.85382 45.85382 V 65.107951 14.018855 H 719.55123 673.69741 V -2.2361432 -18.49114 l 48.65199,0.09784 48.65198,0.09785 2.06869,1.015846 c 1.13778,0.558716 2.5549,1.605699 3.14915,2.32663 2.33264,2.829902 2.18376,-1.852924 2.18376,68.687733 0,70.540651 0.14888,65.857831 -2.18376,68.687731 -0.59425,0.72093 -2.01137,1.76791 -3.14915,2.32663 l -2.06869,1.01584 -48.65198,0.0966 -48.65199,0.0966 z m 0.36106,-20.22536 v -9.567917 h 8.66529 8.66528 v 9.567917 9.56792 h -8.66528 -8.66529 z m 22.38533,0 v -9.567917 h 8.66528 8.66529 v 9.567917 9.56792 h -8.66529 -8.66528 z m 22.10854,0.0903 0.0963,-9.47765 8.75555,-0.09668 8.75555,-0.09668 v 9.57434 9.57434 h -8.85181 -8.85181 z M 674.05847,77.383776 v -9.567922 h 8.66529 8.66528 v 9.567922 9.567923 h -8.66528 -8.66529 z m 22.38533,0 v -9.567922 h 8.66528 8.66529 v 9.567922 9.567923 h -8.66529 -8.66528 z m 22.10854,0.09026 0.0963,-9.47766 8.75555,-0.09668 8.75555,-0.09668 v 9.574343 9.574342 h -8.85181 -8.85181 z m 22.30106,-0.09668 v -9.574343 l 8.75555,0.09668 8.75555,0.09668 0.0963,9.47766 0.0963,9.477659 h -8.85181 -8.85181 z M 674.05847,54.817921 v -9.387396 h 8.66529 8.66528 v 9.387396 9.387396 h -8.66528 -8.66529 z m 22.38533,0 v -9.387396 h 8.66528 8.66529 v 9.387396 9.387396 h -8.66529 -8.66528 z m 22.02427,0 v -9.387396 h 8.84582 8.84581 v 9.387396 9.387396 h -8.84581 -8.84582 z m 22.38533,0 v -9.387396 h 8.84581 8.84582 v 9.387396 9.387396 h -8.84582 -8.84581 z M 696.4438,31.168905 v -9.567923 h 8.66528 8.66529 v 9.567923 9.567922 h -8.66529 -8.66528 z m 22.10854,0.09026 0.0963,-9.477659 8.75555,-0.09668 8.75555,-0.09668 v 9.574342 9.574342 h -8.85181 -8.85181 z m 22.30106,-0.09668 v -9.574342 l 8.75555,0.09668 8.75555,0.09668 0.0963,9.477659 0.0963,9.477659 h -8.85181 -8.85181 z"
       id="path373" /></g></svg>
`;
export default microsoftCalendarIcon;
